import React, { useState } from "react";
import ReactSelect from 'react-select'
import animatedComponents from "react-select/animated"


const SearchableDropdown = ({ disabled, options, onChange, value, name, errors, formValues, label}) => {
    const [isFromCityFocused, setIsFromCityFocused] = useState(false);

    return <div>
          <div
            className={`custom-dropdown relative leading-7 border mx-2 rounded mt-7 lg:mt-3 ${
              isFromCityFocused || formValues ? 'focused' : ''
            } ${
              isFromCityFocused
                ? 'border-primary'
                : disabled
                ? 'border-disable cursor-not-allowed'
                : !!errors
                ? 'border-red-700 form-error'
                : 'border-secondary-200'
            }`}
          >
            <p
              className={`absolute selectbox-label font-medium !text-baseMd ${
                disabled
                  ? 'text-disable-200 cursor-not-allowed'
                  : isFromCityFocused
                  ? 'text-primary'
                  : !!errors
                  ? 'text-red-600'
                  : formValues
                  ? 'text-primary'
                  : 'text-secondary'
              }`}
              style={
                isFromCityFocused || formValues
                  ? { top: '-18px' }
                  : undefined
              }
            >
              {label}
            </p>
          <ReactSelect
            styles={{
              control: (base, state) => ({
                ...base,
                minHeight: '48px',
                borderRadius: 0,
                borderWidth: 0,
                boxShadow: 'none',
                backgroundColor: state.isDisabled ? '#F3F4F6' : '#FFFFFF',
                borderColor: 'transparent',
                '&:hover': {
                  borderColor: 'transparent',
                },
              }),
              valueContainer: (base) => ({
                ...base,
                padding: '0 12px',
              }),
              placeholder: (base) => ({
                ...base,
                color: '#6B7280',
                marginTop: '0px',
              }),
              singleValue: (base) => ({
                ...base,
                color: '#1F2937',
                marginTop: '0px',
              }),
              input: (base) => ({
                ...base,
                color: '#1F2937',
                marginTop: '0px',
              }),
              indicatorSeparator: (base) => ({
                ...base,
                display: 'none',
              }),
              dropdownIndicator: (base, state) => ({
                ...base,
                color: state.isFocused ? '#0ea5e9' : '#6B7280',
                '&:hover': {
                  color: state.isFocused ? '#0ea5e9' : '#6B7280',
                },
              }),
              clearIndicator: (base) => ({
                ...base,
                color: '#6B7280',
                '&:hover': {
                  color: '#374151',
                },
              }),
              menu: (base) => ({
                ...base,
                zIndex: 1000000,
              }),
            }}
            isClearable
            isDisabled={disabled}
            options={options}
            value={value}
            onChange={onChange}
            onFocus={() => setIsFromCityFocused(true)}
            onBlur={() => setIsFromCityFocused(false)}
            components={animatedComponents}
            placeholder={label}
            className="mt-[2px]"
            classNamePrefix="react-select"
          />
          </div>
          {errors ? (
            <p className="text-red-600 mx-2 pl-2">{errors}</p>
          ) : null}
    </div>
};

export default SearchableDropdown;